import {
  select, call, put, takeEvery,
} from 'redux-saga/effects';
import api from 'linkia-api';

import {
  REQUEST_LEAD_EXPORT_CREATE_LEAD,
} from './action-types';

import {
  reqLeadExportCreateSuccess,
  reqLeadExportCreateFailed,
} from './actions';


import { tokenSelector } from '../login/selectors';

function* actionLeadExportCreateLead(action) {
  const token = yield select(tokenSelector);
  const {
    bindingObject,
  } = action;
  try {
    yield call(api.utm.exportLead, {
      bindingObject, token,
    });
    yield put(reqLeadExportCreateSuccess(bindingObject));
  } catch (e) {
    yield put(reqLeadExportCreateFailed());
  }
}

export default [
  takeEvery(REQUEST_LEAD_EXPORT_CREATE_LEAD, actionLeadExportCreateLead),
];
